import { SessionRights } from '../../sessions/providers/session-rights';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConfigProvider } from "../../config-provider.service";
import { CurrentUser } from "../../common/providers/current-user";
import { UtilsProvider } from "../../common/providers/utils-provider.service";
import { ApiBaseService } from "../../common/providers/api-base-service";
import { CurrentUserRolesProvider } from '../../organizations/providers/current-user-roles-provider';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { Organization } from '../../common/models/organization';
import { User } from "../../common/models/user";
import { SessionsProvider } from "../../sessions/providers/sessions-provider";
import { Session } from "../../common/models/session";
import { MobilePageContentComponent } from "../../common/components/mobile-page-content/mobile-page-content";
import { MobileHeaderComponent } from "../../common/components/mobile-header/mobile.header";
import { MobileSideMenuComponent } from "../../common/components/mobile-side-menu/mobile.side-menu.component";
import { SessionsSessionViewComponent } from "../../sessions/components/session-view/session-view";
import { NgIf } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { FlexLayoutModule } from "@angular/flex-layout";

@Component({
  selector: 'app-mobile-sessions-session-page',
  providers: [],
  styleUrls: ['./mobile.session.component.scss'],
  standalone: true,
  imports: [
    MobilePageContentComponent,
    MobileHeaderComponent,
    MobileSideMenuComponent,
    SessionsSessionViewComponent,
    NgIf,
    TranslateModule,
    FlexLayoutModule
  ],
  templateUrl: './mobile.session.component.html'
})
export class MobileSessionComponent implements OnInit, OnDestroy {
    public pageTitle = 'Athlete View';
    public isLoading = true;
    public is401 = false;
    public is404 = false;

    public organization: Organization = {} as Organization;
    public athleteUser: User = {} as User;
    public session: Session = {} as Session;
    public rights: SessionRights = new SessionRights(this._utils);
    private subscriptions: Subscription[] = [];

    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        private _utils: UtilsProvider,
        private api: ApiBaseService,
        private _currentUserRoles: CurrentUserRolesProvider,
        private _route: ActivatedRoute,
        private sessionsProvider: SessionsProvider,
    ) {
    }

    public ngOnInit(): void {
        this.subscriptions.push(
            this._route.data.subscribe((data:any) => { // { organization: Organization; athlete: Athlete }

                this.organization = data.organization;
                this.athleteUser = data.athlete;

                this.subscriptions.push(
                    this._route.params.subscribe((params: any) => {
                        this.initPage(+params['sessionId']);
                    })
                );
            })
        );
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    }


    private initPage(sessionId: number): void {
        this.loadData(sessionId)
            .then(() => {
                this.initNav();
                this.isLoading = false;
            });
    }

    private initNav(): void {
        if (!this.session) {
            this.is404 = true;
            return;
        }

        if (!this.rights.LIST) {
            this.is401 = true;
            return;
        }

        this.createPageTitle();
    }

    private loadData(sessionId: number): Promise<any> {
        return new Promise((resolve, reject) => {

            if (!this.organization) {
                reject({ status: 404 });
                return;
            }
            Promise.all([
                this.sessionsProvider.getSession({id: sessionId})
            ]).then((data: any[]) => {
                this.session = data[0];

                this.rights.evaluateScreenRights({
                    rolesIds: this._currentUserRoles.getRolesIds(this.organization.id!)
                });

                resolve(null);
            })
                .catch(reject);
        });
    }

    private createPageTitle() {
        this.pageTitle = this.session.name ?? '';
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 404) {
            this.is404 = true;
        } else if (error.status === 401) {
            this.is401 = true;
        }
    }
}
